var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconTwitterCampaignCard = function SvgIconTwitterCampaignCard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon-twitter-campaign-card_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M12 .5C5.373.5 0 5.873 0 12.5s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m13.313 11.417 5.137-5.972h-1.217l-4.46 5.185L9.21 5.445H5.1l5.388 7.84L5.1 19.549h1.217l4.71-5.476 3.763 5.476H18.9zM6.757 6.362h1.87l8.606 12.311h-1.87z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon-twitter-campaign-card_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 .5h24v24H0z"
  })))));
};
export default SvgIconTwitterCampaignCard;